import AllhomesNearbySales from './nearby-sales';
export default AllhomesNearbySales;